// src/hooks/useSidebarWidth.ts
// Hook para calcular el ancho máximo de la sidebar y prevenir overflow

import { useState, useEffect } from 'react';

interface SidebarWidthConfig {
  maxWidth: number;
  isMobile: boolean;
  isDesktop: boolean;
}

export function useSidebarWidth(): SidebarWidthConfig {
  const [config, setConfig] = useState<SidebarWidthConfig>(() => {
    const width = typeof window !== 'undefined' ? window.innerWidth : 0;
    const isMobile = width < 1024; // Changed from 640 to 1024 - tablets now behave as mobile
    const isDesktop = width >= 1024;
    
    return {
      maxWidth: isMobile ? width : 500,
      isMobile,
      isDesktop,
    };
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const isMobile = width < 1024;
      const isDesktop = width >= 1024;
      
      setConfig({
        maxWidth: isMobile ? width : 500,
        isMobile,
        isDesktop,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return config;
}
